import { Box, Typography, useTheme } from '@mui/material';
import React from 'react';

import { hexToRGBA } from '../BarChart';

const Title = ({
  title,
  icon,
  color,
  iconSize = 36,
  titleSize = '1.2rem',
}: {
  title: string;
  icon: React.ReactNode;
  color: string;
  iconSize?: number;
  titleSize?: string;
}) => {
  const theme = useTheme();

  const getBackgroundColor = () => {
    if (color.startsWith('#')) return hexToRGBA(color, 0.12);
    try {
      const themeColor = theme.palette[color as keyof typeof theme.palette];
      if (typeof themeColor === 'string') {
        return hexToRGBA(themeColor, 0.12);
      } else if (
        themeColor &&
        typeof themeColor === 'object' &&
        'main' in themeColor
      ) {
        return hexToRGBA(themeColor.main, 0.12);
      }
    } catch (error) {
      console.error('Error getting theme color:', error);
    }
    return hexToRGBA(theme.palette.primary.main, 0.12);
  };

  return (
    <Box
      style={{
        display: 'flex',
        alignItems: 'center',
        gap: 10,
        marginBottom: 12,
      }}
    >
      <Box
        style={{
          width: iconSize,
          height: iconSize,
          borderRadius: 8,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          background: getBackgroundColor(),
        }}
      >
        {icon}
      </Box>
      <Typography
        variant="h5"
        sx={{
          fontWeight: 500,
          color: 'text.primary',
          fontSize: titleSize,
        }}
      >
        {title}
      </Typography>
    </Box>
  );
};

export default Title;
